<template>
  <div class="second-per">
      <span>{{label}}</span>
      <input
       type="number"
       :value="value"
       @input="inputChange"
       />
      <div>单位／秒</div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
  },
  methods: {
    inputChange(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
   .second-per {
       display: flex;
       align-items: center;
       margin-top: 33px;
       span {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #A1A7C4;
       }
       input {
         background: #FFFFFF;
         border: 1px solid #D9E1EC;
         border-radius: 4px;
         width: 151px;
         height: 36px;
         font-family: PingFangSC-Semibold;
         font-size: 14px;
         color: #1E5EFF;
         text-align: center;
         margin-left: 24px;
         margin-right: 10px;
       }
       :last-child {
         font-family: PingFangSC-Semibold;
         font-size: 14px;
         color: #000000;
       }
   }
</style>
